export const getDayOptions = () => [...Array(31)].map((x, i) => ({ value: `${i + 1}`, label: `${i + 1}` }));
export const getMonthOptions = () => {
    const currentDate = new Date();
    return [...Array(12)].map((_, i) => {
        const month = new Date(currentDate.getFullYear(), i, 1).toLocaleString('default', { month: 'short' });
        return { value: `${(i + 1)}`.padStart(2, '0'), label: month };
    });
};
export const getYearOptions = (maybeMinDate, maybeMaxDate) => {
    const currentDate = maybeMaxDate ? maybeMaxDate.getFullYear() : new Date().getFullYear() + 5;
    const minYear = maybeMinDate ? currentDate - (currentDate - maybeMinDate.getFullYear()) : currentDate - 120;
    console.log(`Current year ${currentDate} min year ${minYear}`);
    const years = [];
    // eslint-disable-next-line no-plusplus
    for (let i = currentDate; i >= minYear; i--) {
        years.push({ value: `${i}`, label: `${i}` });
    }
    return years;
};
